// This file was automatically generated by TanStack Router.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

import { Route as rootRouteImport } from './routes/__root'
import { Route as UsersRouteImport } from './routes/users'
import { Route as QueueRouteImport } from './routes/queue'
import { Route as PrintingsRouteImport } from './routes/printings'
import { Route as MfaRouteImport } from './routes/mfa'
import { Route as LoginRouteImport } from './routes/login'
import { Route as ExpansionsRouteImport } from './routes/expansions'
import { Route as CardsRouteImport } from './routes/cards'
import { Route as AdminsRouteImport } from './routes/admins'
import { Route as AccountRouteImport } from './routes/account'
import { Route as IndexRouteImport } from './routes/index'
import { Route as UsersIndexRouteImport } from './routes/users/index'
import { Route as UsersIdRouteImport } from './routes/users/$id'
import { Route as QueueIndexRouteImport } from './routes/queue/index'
import { Route as QueueIdRouteImport } from './routes/queue/$id'

const UsersRoute = UsersRouteImport.update({
            id: '/users',path: '/users',getParentRoute: () => rootRouteImport
          })
const QueueRoute = QueueRouteImport.update({
            id: '/queue',path: '/queue',getParentRoute: () => rootRouteImport
          })
const PrintingsRoute = PrintingsRouteImport.update({
            id: '/printings',path: '/printings',getParentRoute: () => rootRouteImport
          })
const MfaRoute = MfaRouteImport.update({
            id: '/mfa',path: '/mfa',getParentRoute: () => rootRouteImport
          })
const LoginRoute = LoginRouteImport.update({
            id: '/login',path: '/login',getParentRoute: () => rootRouteImport
          })
const ExpansionsRoute = ExpansionsRouteImport.update({
            id: '/expansions',path: '/expansions',getParentRoute: () => rootRouteImport
          })
const CardsRoute = CardsRouteImport.update({
            id: '/cards',path: '/cards',getParentRoute: () => rootRouteImport
          })
const AdminsRoute = AdminsRouteImport.update({
            id: '/admins',path: '/admins',getParentRoute: () => rootRouteImport
          })
const AccountRoute = AccountRouteImport.update({
            id: '/account',path: '/account',getParentRoute: () => rootRouteImport
          })
const IndexRoute = IndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => rootRouteImport
          })
const UsersIndexRoute = UsersIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => UsersRoute
          })
const UsersIdRoute = UsersIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => UsersRoute
          })
const QueueIndexRoute = QueueIndexRouteImport.update({
            id: '/',path: '/',getParentRoute: () => QueueRoute
          })
const QueueIdRoute = QueueIdRouteImport.update({
            id: '/$id',path: '/$id',getParentRoute: () => QueueRoute
          })





const QueueRouteChildren = {
  QueueIdRoute: QueueIdRoute,QueueIndexRoute: QueueIndexRoute
}

const QueueRouteWithChildren = QueueRoute._addFileChildren(QueueRouteChildren)




const UsersRouteChildren = {
  UsersIdRoute: UsersIdRoute,UsersIndexRoute: UsersIndexRoute
}

const UsersRouteWithChildren = UsersRoute._addFileChildren(UsersRouteChildren)

const rootRouteChildren = {
  IndexRoute: IndexRoute,AccountRoute: AccountRoute,AdminsRoute: AdminsRoute,CardsRoute: CardsRoute,ExpansionsRoute: ExpansionsRoute,LoginRoute: LoginRoute,MfaRoute: MfaRoute,PrintingsRoute: PrintingsRoute,QueueRoute: QueueRouteWithChildren,UsersRoute: UsersRouteWithChildren
}
export const routeTree = rootRouteImport._addFileChildren(rootRouteChildren)